













































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import {
  AppUserBillableTargetHistoryEditModel,
  AppUserBillableTargetHistoryFilter,
  AppUserEditModel,
  AppUserHistoryEditModel,
  AppUserHistoryFilter,
  AppUserInternalCostHistoryEditModel,
  AppUserInternalCostHistoryFilter,
  AppUserRightEditModel,
  AppUserVacationHistoryEditModel,
  AppUserVacationHistoryFilter,
  AppUserViewModel,
  AuthorizedProjectList,
  ProjectStaffEditModel,
  ProjectStaffFilter,
  RightEnum,
  RoleViewModel,
  StSelectListItemGroup,
} from '@/services/api/nswag/stapiclient_generated';
import {
  appUserRightApi,
  projectStaffApi,
  roleApi,
  stAppUserApi,
  stAppUserBillableTargetHistoryApi,
  stAppUserHistoryApi,
  stAppUserInternalCostHistoryApi,
  stAppUserVacationHistoryApi,
  stProjectApi,
  stPublicHolidayGroupApi,
} from '@/services/st-api';
import { UserStore } from '@/store/user-module';
import AppUserHistory from '@/views/User/History/AppUserHistory.vue';
import AppUserVacationHistory from '@/views/User/VacationHistory/AppUserVacationHistory.vue';
import SlideIn from '@/components/basic/SlideIn.vue';
import StInput2 from '@/components/basic/StInput2.vue';
import StSelect from '@/components/basic/StSelect.vue';
import StToggle from '@/components/basic/StToggle.vue';
import { notifySuccess } from '@/utlitities/notifications';
import StExplanation from '@/components/basic/StExplanation.vue';
import AppUserProjectStaffEdit from '@/views/User/AppUserProjectStaffEdit.vue';
import { TabModel } from '@/components/tabs/tab-model';
import StTabs from '@/components/tabs/StTabs.vue';
import RoleExplanationTable from '@/views/User/RoleExplanationTable.vue';
import AppUserInternalCostHistory from '@/views/User/InternalCostHistory/AppUserInternalCostHistory.vue';
import AppUserBillableTargetHistory from '@/views/User/BillableTargetHistory/AppUserBillableTargetHistory.vue';

@Component({
  components: {
    AppUserBillableTargetHistory,
    AppUserInternalCostHistory,
    RoleExplanationTable,
    StTabs,
    StExplanation,
    AppUserHistory,
    AppUserVacationHistory,
    SlideIn,
    StInput2,
    StSelect,
    StToggle,
    AppUserProjectStaffEdit,
  },
})
export default class EditUser extends Vue {
  loading = false;
  userEditModel: AppUserEditModel = AppUserEditModel.fromJS({ email: '' });
  userId: number = 0;
  publicHolidayGroupOptions: StSelectListItemGroup[] = [];
  roles: RoleViewModel[] = [];
  possibleManager: AppUserViewModel[] = [];
  appUserRights: AppUserRightEditModel[] = [];
  authorizedProjects: AuthorizedProjectList = AuthorizedProjectList.fromJS({
    canAccessAllProjects: true,
    projects: [],
  });
  listPage = 'User';
  private saving: boolean = false;
  private historyItems: AppUserHistoryEditModel[] = [];
  private internalCostHistoryItems: AppUserInternalCostHistoryEditModel[] = [];
  private vacationHistoryItems: AppUserVacationHistoryEditModel[] = [];
  private billableTargetHistoryItems: AppUserBillableTargetHistoryEditModel[] = [];
  projectStaffEditModels: ProjectStaffEditModel[] = [];

  activeTabName = 'standard';

  get tabs(): TabModel[] {
    let res = [
      {
        TabName: 'standard',
        Disabled: false,
      },
    ];

    if (UserStore.userSettings.useAbsences) {
      res.push({
        TabName: 'vacation',
        Disabled: false,
      });
    }

    return res;
  }

  async roleChanged() {
    await this.loadAppUserRights();
  }

  get featureFlagAppUserDepartmentInfo(){
    return UserStore.userSettings.featureFlagAppUserDepartmentInfo;
  }

  get useEmployeeData() {
    return UserStore.userSettings.featureFlagEmployeeData;
  }

  get useProjectTimeTracking() {
    return !UserStore.userSettings.useBasicTimeTracking;
  }

  get filteredAppUserRights() {
    return this.appUserRights.filter((x) => !x.hidden) ?? [];
  }

  get canEditMasterData() {
    return this.appUserRights.some((x) => x.isMasterDataRight && x.isAllowed);
  }

  get selectedRole() {
    return this.roles.find((x) => x.id == this.userEditModel.roleId);
  }

  get hasAppUserRights() {
    return this.selectedRole?.hasAppUserRights;
  }

  get hasRightAllProjects() {
    return this.appUserRights.some((x) => x.rightEnum == RightEnum.CanEditTimeEntriesForAllProjects && x.isAllowed);
  }

  get canViewTimeEntriesForEmployees() {
    return this.appUserRights.some((x) => x.rightEnum == RightEnum.CanViewTimeEntriesForEmployees && x.isAllowed);
  }

  get canViewCustomerAndProjects() {
    return this.appUserRights.some((x) => x.rightEnum == RightEnum.CanViewCustomerAndProjects && x.isAllowed);
  }

  get canEditTimeEntriesForEmployees() {
    return this.appUserRights.some((x) => x.rightEnum == RightEnum.CanEditTimeEntriesForEmployees && x.isAllowed);
  }

  get noActiveProject() {
    return (
      (!this.hasRightAllProjects && !this.projectStaffEditModels.length) ||
      (this.authorizedProjects.projects?.length && this.authorizedProjects.projects?.every((x) => x.isArchived))
    );
  }

  get useTimeAccount() {
    return UserStore.userSettings.useTimeAccount;
  }

  get useInternalUserCost() {
    return UserStore.userSettings.useInternalUserCost;
  }

  get useBillableTarget() {
    return UserStore.userSettings.featureFlagBillableTarget;
  }

  openSlideIn() {
    (this.$refs.slideIn as SlideIn).open();
  }

  closeSlideIn() {
    (this.$refs.slideIn as SlideIn).close();
  }

  slideOutClosed() {
    this.$router.push({ name: this.listPage });
  }

  async created() {
    this.loading = true;
    this.userId = parseInt(this.$route.params.id);
  }

  async mounted() {
    this.loading = true;
    this.openSlideIn();
    if (this.userId == 0) {
      this.userEditModel = await stAppUserApi.getNew();
    } else {
      this.userEditModel = await stAppUserApi.get(this.userId);
      this.authorizedProjects = await stProjectApi.getAuthorizedProjectListByAppUser(this.userId);
    }

    this.possibleManager = await stAppUserApi.getManagerList(this.userId);

    if (!this.userEditModel.timeRoundingInterval) {
      this.userEditModel.timeRoundingInterval = 15;
    }

    this.publicHolidayGroupOptions = await stPublicHolidayGroupApi.getGroupedSelectList();
    this.historyItems = await stAppUserHistoryApi.getList(AppUserHistoryFilter.fromJS({ appUserId: this.userEditModel.id }));
    this.internalCostHistoryItems = await stAppUserInternalCostHistoryApi.getList(AppUserInternalCostHistoryFilter.fromJS({ appUserId: this.userEditModel.id }));

    this.vacationHistoryItems = await stAppUserVacationHistoryApi.getList(AppUserVacationHistoryFilter.fromJS({ appUserId: this.userEditModel.id }));
    this.billableTargetHistoryItems = await stAppUserBillableTargetHistoryApi.getList(AppUserBillableTargetHistoryFilter.fromJS({ appUserId: this.userEditModel.id }));

    this.roles = await roleApi.getList();
    await this.loadAppUserRights();
    await this.loadProjectStaffEditModels();

    this.loading = false;
    await this.$nextTick();
  }

  get featureFlagPassiveUsers() {
    return UserStore.userSettings.featureFlagPassiveUsers;
  }

  get featureFlagMixedUsers() {
    return UserStore.userSettings.featureFlagMixedUsers;
  }

  rightIsDisabled(right: AppUserRightEditModel) {
    return right.rightEnum == RightEnum.CanEditTimeEntriesForAllProjects && (this.canEditMasterData || this.canViewCustomerAndProjects);
  }

  isCanViewTimeEntriesForEmployees(right: AppUserRightEditModel) {
    return right.rightEnum == RightEnum.CanViewTimeEntriesForEmployees;
  }

  isCanViewCustomerAndProjects(right: AppUserRightEditModel) {
    return right.rightEnum == RightEnum.CanViewCustomerAndProjects;
  }

  get canWriteAllEmployeesAndProjects() {
    return (
      this.appUserRights.find((x) => x.rightEnum == RightEnum.CanEditTimeEntriesForAllProjects)?.isAllowed &&
      this.appUserRights.find((x) => x.rightEnum == RightEnum.CanEditTimeEntriesForEmployees)?.isAllowed
    );
  }

  rightChanged(right: AppUserRightEditModel) {
    if (right.isMasterDataRight && this.canEditMasterData) {
      this.appUserRights.find((x) => x.rightEnum == RightEnum.CanEditTimeEntriesForAllProjects)!.isAllowed = true;
      this.appUserRights.find((x) => x.rightEnum == RightEnum.CanViewCustomerAndProjects)!.isAllowed = true;
    }

    if (right.rightEnum == RightEnum.CanViewCustomerAndProjects && this.canViewCustomerAndProjects) {
      this.appUserRights.find((x) => x.rightEnum == RightEnum.CanEditTimeEntriesForAllProjects)!.isAllowed = true;
    }

    if (this.canWriteAllEmployeesAndProjects) {
      this.appUserRights.find((x) => x.rightEnum == RightEnum.CanViewTimeEntriesForEmployees)!.isAllowed = true;
    }
  }

  async loadProjectStaffEditModels() {
    if (this.hasAppUserRights) {
      this.projectStaffEditModels = await projectStaffApi.getEditModels(ProjectStaffFilter.fromJS({ appUserId: this.userId }));
    }
  }

  async loadAppUserRights() {
    if (this.hasAppUserRights) {
      this.appUserRights = await appUserRightApi.getEditModels(this.userEditModel.id!);
    }
  }

  async submit() {
    try {
      this.saving = true;
      let appUserid = 0;
      let successText = 'Erfolgreich gespeichert';

      if (this.userEditModel.id == 0) {
        appUserid = await stAppUserApi.post(this.userEditModel);
        successText = 'Benutzer angelegt und Einladung per E-Mail versendet';
      } else {
        appUserid = await stAppUserApi.put(this.userEditModel.id, this.userEditModel);
      }

      await stAppUserHistoryApi.merge(appUserid, this.historyItems);
      await stAppUserInternalCostHistoryApi.merge(appUserid, this.internalCostHistoryItems);
      await stAppUserVacationHistoryApi.merge(appUserid, this.vacationHistoryItems);
      await stAppUserBillableTargetHistoryApi.merge(appUserid, this.billableTargetHistoryItems);

      if (this.hasAppUserRights) {
        await appUserRightApi.merge(appUserid, this.appUserRights);
        await projectStaffApi.mergeByAppUser(appUserid, this.projectStaffEditModels);
      }
      await UserStore.reloadStore();

      notifySuccess(successText);

      this.closeSlideIn();
    } finally {
      this.saving = false;
    }
  }
}
